export default __webpack_public_path__ + "static/3-63a1e69ed54469201ac8a57fc81eef69.png";